import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { readingEntries } from "@/mocks/home";

export default function ReadingEntries() {
  return (
    <section id="entries" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-10 py-16 md:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="阅读入口"
            title="三种方式，抵达你想读的那一章"
            desc="在线看、txt 下载、无删减版，内容一致，只是阅读习惯不同。选一条最适合你的路径就好。"
            align="center"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {readingEntries.map((entry, index) => (
            <Reveal key={entry.title} delay={index * 90}>
              <div className="group h-full flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-6 transition-colors hover:border-primary-300">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${entry.icon} text-2xl`} />
                </div>
                <h3 className="mt-5 font-heading text-lg text-foreground-950">{entry.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>

                <div className="mt-6 flex items-center justify-between border-t border-background-100 pt-5">
                  <span className="text-xs font-label text-foreground-400">{entry.note}</span>
                  <a
                    href="#chapters"
                    className="inline-flex items-center gap-1.5 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {entry.action}
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}